/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
import React, { useState } from "react";
import Carousel from "react-elastic-carousel";
import {
  renderCarouselArrow,
  renderCarouselPagination,
} from "utils/elasticCarouselRenderers";
import * as Styles from "./styles";
import { ProductCard } from "./components";
import DialogCommon from "../../../components/dialogCommon";
import { PreferenciasDoLead } from "../../../components/dialogCommon/templates/preferenciasDoLead";
import * as IconsSVG from "../../../assets/iconsSVG";
import { DataResponse } from "../../../services/api";

interface Product {
  idProduto: string;
  nomeProduto: string;
  idBandeira: string;
  nomeBandeira: string;
  fase: undefined | string;
  fotoProduto: undefined | string;
}
interface Props {
  openModalDadosComplementares: () => void;
  produtosInteresse: Product[] | undefined;
  dataLead: DataResponse | undefined;
  readOnly?: boolean;
}

export function ProdutosInteresse(props: Props) {
  const [preferenciasDoLead, setPreferenciasDoLead] = useState(false);
  const hasProducts = (props.produtosInteresse?.length ?? 0) > 0;
  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 3, itemsToScroll: 1 },
    { width: 768, itemsToShow: 3 },
    { width: 900, itemsToShow: 3 },
  ];

  const carouselRenderOptions = {
    arrowClassName: "produtos-interesse-arrow",
    paginationClassName: "produtos-interesse-pagination",
    paginationItemClassName: "produtos-interesse-pagination-item",
  };

  return (
    <>
      <Styles.Container>
        <h3>Produtos de interesse</h3>
        <Styles.ContainerCards>
          {hasProducts ? (
            <Styles.CarouselWrapper>
              {/* @ts-ignore */}
              <Carousel
                renderPagination={renderCarouselPagination(
                  carouselRenderOptions
                )}
                renderArrow={renderCarouselArrow(carouselRenderOptions)}
                isRTL={false}
                breakPoints={breakPoints}
              >
                {props.produtosInteresse?.map((produto: Product) => (
                  <ProductCard
                    key={produto.idProduto}
                    idEmpreendimento={produto.idProduto}
                    nomeEmpreendimento={produto.nomeProduto}
                    nomeBandeira={produto.nomeBandeira}
                    urlImagemPrincipal={produto.fotoProduto}
                    statusEmpreendimento={produto.fase}
                  />
                ))}
              </Carousel>
            </Styles.CarouselWrapper>
          ) : (
            <Styles.EmptyState>Nenhum registro encontrado</Styles.EmptyState>
          )}
        </Styles.ContainerCards>
        <Styles.DadosCompContainer>
          <button type="button" onClick={() => setPreferenciasDoLead(true)}>
            Visualizar preferências do lead
          </button>
        </Styles.DadosCompContainer>
      </Styles.Container>
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setPreferenciasDoLead}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Preferências"
        isFilter={false}
        isClose
        width={800}
        height={650}
        component={
          <>
            <PreferenciasDoLead
              idLeadCorretor={
                props?.dataLead?.idLeadCorretor
                  ? props?.dataLead?.idLeadCorretor
                  : ""
              }
              closeModal={() => setPreferenciasDoLead(false)}
              refetchDataLead={() => {}}
              readOnly={props.readOnly}
            />
          </>
        }
        setOpenModal={setPreferenciasDoLead}
        open={preferenciasDoLead}
        icon={<IconsSVG.PreferenciasIcon />}
      />
    </>
  );
}
